module.exports = __webpack_public_path__ + "img/carousel-icon.1bd8322e.svg";